import React from 'react';
import styles from '../styles/SuccessPage.module.css'; // Создай CSS-модуль

const SuccessPage = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.h2}>✅ Оплата прошла успешно!</h2>
        <p className={styles.p}>Благодарим за покупку. Все функции тарифа и сервисы активированы.</p>
        <a href="/" className={styles.link}>Вернуться на главную</a>
      </div>
    </div>
  );
};

export default SuccessPage;
